var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSweden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 40C31.0454 40 39.9997 31.0457 39.9997 20C39.9997 8.9543 31.0454 0 19.9997 0C8.95397 0 -0.000335693 8.9543 -0.000335693 20C-0.000335693 31.0457 8.95397 40 19.9997 40Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6519 17.3913H39.8304C38.552 7.57828 30.1612 0 19.9997 0C18.5064 0 17.0518 0.165078 15.6519 0.475391V17.3913H15.6519Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4346 17.3913V2.43182C4.94285 5.42823 1.01152 10.9244 0.169098 17.3914H10.4346V17.3913Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4345 22.6088H0.169098C1.01152 29.0757 4.94285 34.5719 10.4346 37.5682L10.4345 22.6088Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6519 22.6088V39.5247C17.0518 39.835 18.5064 40.0001 19.9997 40.0001C30.1612 40.0001 38.552 32.4218 39.8304 22.6088H15.6519V22.6088Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweden);
export default __webpack_public_path__ + "static/media/sweden.295e1135f9d3d6c23894810a5c0fe616.svg";
export { ForwardRef as ReactComponent };